module.exports = __webpack_public_path__ + "static/roadmap2010-458954c6d9ef14bf100660e601033d33.svg";